import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'tpc-calculator',
    templateUrl: './calculator.component.html',
    styleUrls: ['./calculator.component.css']
})
export class CalculatorComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator.component.ts